import { TFunction } from "i18next";
import { IPreparedLogs } from "interfaces";

export const getlogsColumns = (t: TFunction) => [

  {
    title: t('Logs.table.columns.date'),
    dataIndex: 'date',
    key: 'date',
    width: '20%',
    sorter: (a: IPreparedLogs, b: IPreparedLogs) => (a.number_timestamp || 0) - (b.number_timestamp || 1),
  },
  {
    title: t('Logs.table.columns.action'),
    dataIndex: 'action',
    key: 'action',
    width: '20%',
  },
  {
    title: t('Logs.table.columns.document'),
    dataIndex: 'entityname',
    key: 'entityname',
    width: '25%',
  },
  {
    title: t('Logs.table.columns.username'),
    dataIndex: 'username',
    key: 'username',
    width: '20%',
  },
  {
    title: t('Logs.table.columns.email'),
    dataIndex: 'email',
    key: 'email',
    width: '15%',
  },
];

export const getlogsColumnsForPrint = (t: TFunction) => [
  ...getlogsColumns(t).filter(el => el.dataIndex !== 'details'),
  {
    title: t('Logs.logsModal.document_size'),
    dataIndex: 'size',
    key: 'size',
    width: '6%',
  },
];



